

import { Locale } from 'vant';
// 引入英文语言包
// import en_US from 'vant/es/locale/lang/en-US';
// import zh_CN from 'vant/es/locale/lang/zh-CN';
// Locale.use('en-US', en_US);

const messages = {
    en_US : require('@/assets/languages/en-US.json'),
    zh_CN: require('@/assets/languages/zh-CN.json'),
  };

const locale = "zh_CN";

import { createI18n } from "vue-i18n";

const i18n = createI18n({
   // 使用 Composition API 模式，则需要将其设置为false
   legacy: false,
   // 全局注入 $t 函数
   globalInjection: true,
   locale,
   messages,
 });


export default i18n
